<script lang="ts">
	import { appendBonusPointsWord, formatPoints } from '$services/PointsFormatter.js';

	export let compensationAmount: number;
	export let compensationHeadline: string = 'Verdiene';
	export let isHorizontal: boolean = false;
	export let showNewProgramStructure: boolean = false;

</script>

<div class="achievement-footer-container oc-mt-75" class:footer--horizontal={isHorizontal} data-testid="achievement-footer">
	<div class="compensation-container">
		<span class="oc-copy-75">{compensationHeadline}:</span>
		{#if showNewProgramStructure === true }
			<span class="oc-copy-75 oc-copy--bold">{appendBonusPointsWord(compensationAmount)}</span>
		{:else}
			<span class="oc-copy-75 oc-copy--bold">{formatPoints(compensationAmount)} Punkte</span>
		{/if}
	</div>
	<div class="cta-container">
		<slot></slot>
	</div>
</div>


<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";
  @use '@otto-ec/otto-components-utils/scss/mixins' as mixins;

  .separator {
    border-top: 1px solid tokens.$oc-base-color-gray-100;
  }

  .achievement-footer-container {
    display: flex;
    justify-content: space-between;
    align-items: center;

		&.footer--horizontal{
			@include mixins.breakpoint(mixins.$breakpoint-l) {
				flex-direction: column;
				align-items: flex-end;
				margin-top: 0px !important;

        & .compensation-container {
          align-items: flex-end;
          margin-bottom: tokens.$oc-semantic-spacing-75;
        }
			}
		}

		.compensation-container {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
		}
  }

</style>
